import { QUERY_PROJECT_DETAILS, QUERY_PROPERTY_DETAILS } from "../../GQL";

import { PropComponentMode } from "../../Components/Property/PropertyInterfaces";
import { useQuery } from "@apollo/client";
import { fetchSearchResults } from "src/services/search";
import { useContext, useEffect, useState } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

type HookResponse = {
	listing: Listing;
	loading: boolean;
};

const mapTechnicalSheet = (technicalSheet = [], property) => {
	const showAddressMap = item => {
		if (item.field === "address") {
			if (property && property.showAddress) {
				return item;
			} else {
				const value = null;
				return { ...item, value };
			}
		} else {
			return item;
		}
	};

	if (Array.isArray(technicalSheet)) {
		return technicalSheet.map(showAddressMap);
	} else {
		return [];
	}
};

const makeListingData = (data: any, mode: PropComponentMode): Listing => {
	if (data && (data.project || data.property)) {
		if (mode === "project" && data.project) {
			let property = {};
			let technicalSheet = [];
			if (data.project?.commercial_units[0]) {
				property = { ...data.project?.commercial_units[0] };
				property["active"] = property["active"] && property["owner"]?.active;
				technicalSheet =
					property &&
						property["technicalSheet"] &&
						Array.isArray(property["technicalSheet"])
						? mapTechnicalSheet(property["technicalSheet"], property)
						: [];
			}
			const { title, bedrooms, bathrooms, active, address, images } = data.project; // Preservamos data de proyecto

			let activeProject: boolean = active;
			if (data.project?.commercial_units) {
				let hasActiveUnit = false;
				data.project?.commercial_units.map(item => {
					if (item.active) hasActiveUnit = true;
				});
				activeProject = hasActiveUnit && activeProject;
			}

			return {
				...data.project,
				...property,
				title,
				bedrooms,
				bathrooms,
				active: activeProject,
				images,
				isProject: true,
				address,
				technicalSheet,
			};
		} else if (data.property) {
			const technicalSheet =
				data.property &&
					data.property.technicalSheet &&
					Array.isArray(data.property.technicalSheet)
					? mapTechnicalSheet(data.property.technicalSheet, data.property)
					: [];

			const property = { ...data.property, technicalSheet };
			property.active = property.active && property.owner?.active;

			let projectImgs = property.project[0]?.images ?? [];
			property.images = [...property.images, ...projectImgs];

			if (
				data.property.project &&
				data.property.project.length &&
				data.property.project[0].description
			) {
				property.description = data.property.project[0].description + property.description;
			}
			return property;
		}
	}

	const currency = {
		name: "",
	};
	const price = {
		amount: 0,
		currency,
	};
	return {
		id: "",
		title: "",
		subtitle: "",
		description: "",
		link: "",
		slug: "",
		property_type: null,
		bedrooms: 0,
		rooms: 0,
		bathrooms: 0,
		m2: 0,
		minM2: 0,
		guests: 0,
		hectares: 0,
		facilities: [],
		active: true,
		operation_type: null,
		price: price,
		commonExpenses: {
			...price,
			hide: false,
		},
		price_amount_usd: 0,
		price_variation: {
			...price,
			difference: 0,
			percentage: 0,
			date: "",
		},
		technicalSheet: [],
		images: [],
		img: "",
		files: [],
		image_count: 0,
		youtube: "",
		owner: null,
		architect: "",
		builder: "",
		percentage_finished: 0,
		percentage_sold: 0,
		ocupation: null,
		isExternal: false,
		finalization: "",
		constructionState: { name: "" },
		code: "",
		seller: null,
	};
};

export const usePropertyDetailsTwo = (
	id: string,
	mode: PropComponentMode = "auto"
): HookResponse => {
	const { main_domain } = useContext(ConfigStateContext);
	const [newData, setNewData] = useState<any>({});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		const payload = {
			rows: 1,
			params: {
				id,
			},
			page: 1,
			source: 10,
		};
		fetchSearchResults(payload, main_domain)
			.then(res => {
				setNewData(res);
				setLoading(false);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	}, [id]);

	const listing = makeListingData(newData, mode);
	return {
		listing,
		loading,
	};
};

